<template>
  <div class="baxia-scan-page">
    <!-- 顶部banner -->
    <img class="banner-img" src="/static/images/bx/banner.png">
    
    <!-- 提示文字 -->
    <div class="scan-tip">点击下方按钮扫码查询</div>
    
    <!-- 扫码按钮图片 -->
    <img class="scan-btn" src="/static/images/bx/scan.png" @click="handleScanClick">
    
    <!-- 输入数码提示 -->
    <div class="input-tip">若二维码破损请输入数码</div>
    
    <!-- 数码输入框 -->
    <input class="digital-input" type="text" placeholder="请输入16位数码" v-model="inputCode" maxlength="16" @input="handleInputChange">
    
    <!-- 查询按钮图片 -->
    <img class="query-btn" src="/static/images/bx/query.png" @click="handleQueryClick">
  </div>
</template>

<style scoped>
.baxia-scan-page {
  width: 100vw;
  min-height: 100vh;
  background-color: rgb(246, 246, 246);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
}

.banner-img {
  width: 100vw;
  height: auto;
  margin-top: 0;
}

.scan-tip {
  margin-top: 4vh;
  font-size: 4.3vw;
  color: black;
  text-align: center;
}

.scan-btn {
  margin-top: 3vh;
  width: 35vw;
  height: auto;
}

.input-tip {
  margin-top: 5vh;
  font-size: 4vw;
  color: black;
  text-align: center;
}

.digital-input {
  margin-top: 3vh;
  width: 70vw;
  padding: 1.5vh 1vw;
  background-color: white;
  border: none;
  border-radius: 2.5vw;
  text-align: center;
  font-size: 4vw;
  outline: none;
  display: block;
  box-sizing: border-box;
}

.digital-input::placeholder {
  font-size: 3.7vw;
  color: #999;
}

.query-btn {
  margin-top: 3vh;
  width: 40vw;
  height: auto;
  margin-bottom: 3vh;
}

/* 小屏幕设备适配 (iPhone 5/SE等) */
@media screen and (max-height: 667px) {
  .banner-img {
    max-height: 28vh;
    object-fit: cover;
  }
  
  
  .digital-input {
    padding: 1.2vh 1vw;
  }
}
</style>

<script>
import { getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'

export default {
  name: 'BaXiaScan',
  data() {
    return {
      eno: '138823261350', // 企业号
      inputCode: '' // 输入的数码
    }
  },
  methods: {
    handleScanClick() {
      // 使用微信扫码功能
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          var scanResult = res.resultStr
          var scanQRCode = scanResult
          if (scanResult.startsWith('http')) {
            let parts = scanResult.split('/')
            scanQRCode = parts.length > 0 ? parts[parts.length - 1] : ''
            scanQRCode = scanQRCode.substring(0, 16)
          }
          // 跳转到index页面，并传递扫码结果
          this.$router.push({ 
            path: '/bxia/index', 
            query: { 
              c: scanQRCode
            } 
          })
        }
      })
    },
    handleInputChange() {
      // 只允许输入数字
      this.inputCode = this.inputCode.replace(/[^0-9]/g, '')
    },
    handleQueryClick() {
      // 获取输入框的值
      const inputValue = this.inputCode.trim()
      if (!inputValue) {
        alert('请输入数码')
        return
      }
      // 校验是否为16位纯数字
      if (!/^\d{16}$/.test(inputValue)) {
        alert('请输入16位纯数字')
        return
      }
      // 跳转到index页面，并传递输入的数码
      this.$router.push({ 
        path: '/bxia/index', 
        query: { 
          c: inputValue
        } 
      })
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, "wx1e7875f5abb1fa0a").then(res => {
        const data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录1
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseimg',
            'predivimg',
            'uploadimg',
            'downloadimg',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificdiv',
            'addCard',
            'chooseCard',
            'openCard'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });

      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  },
  mounted() {
    // 初始化
    this.getWxJs()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/BaXia/Scan.vue